import axios from '../axios';
import { checkResponse, getProjectId } from '../utils';
import { apiV1 } from '../utils/constant';

/**
 * @function getSignTask
 * @desc 获取签到任务
 */
function getSignTask() {
  return axios.get(`${apiV1}/projects/${getProjectId()}/tasks/checkin`).then(checkResponse);
}

/**
 * @function getSignList
 * @desc 获取签到列表
 */
function getSignList(id, query = null) {
  return axios.get(`${apiV1}/projects/${getProjectId()}/tasks/${id}/ucases?${query}`).then(checkResponse);
}

/**
 * @function getSignListQuick
 * @desc 获取签到列表
 */
function getAllSignList(id, params = {}) {
  return axios.get(`${apiV1}/projects/${getProjectId()}/tasks/${id}/ucases/index_quick`, {params}).then(checkResponse);
}

/**
 * @function getSignAreaCount 获取点位数量
 * @returns {Array} res.counts 点位数量
 */
const getSignAreaCount = (id) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/ucases/group_by?fields=area_id&taskId=${id}&queryAllp=true`)
    .then(checkResponse)
}

/**
 * @function getSignUcaseAreaCount 获取点位数量
 * @returns {Array} res.counts 点位数量
 */
const getSignUcaseAreaCount = (id) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/ucases/group_by?fields=area_id&taskId=${id}`)
    .then(checkResponse)
}

/**
 * @function getSignDetail 获取详情
 * @returns {Array} res.counts 点位数量
 */
const getSignDetail = (taskid, ucaseid) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/tasks/${taskid}/ucases/${ucaseid}/spec?datetime_format=datetime&view=web`)
    .then(checkResponse)
}

/**
 * @function getUcaseMap 获取案件地图数据
 * @param {String} points 点位
 * @param {String} search 格式化后的查询条件
 * @returns {Object} data 地图数据
 */
const getSignMap = (taskid, search) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/tasks/${taskid}/ucases/index_quick?datetimeFormat=datetime${search ? `&${search}` : ''}`
    )
    .then(checkResponse)
}
export{
  getSignTask,
  getSignList,
  getAllSignList,
  getSignAreaCount,
  getSignDetail,
  getSignMap,
  getSignUcaseAreaCount
}
